import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';
import { FpLoggerNoiseMinNoiseChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise-chart.service';
import { FpLoggerNoiseMinNoiseConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise-connect.service';
import { FpLoggerNoiseMinNoiseExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise-export.service';
import { FpLoggerNoiseMinNoiseStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/services/fp-logger-noise-min-noise/fp-logger-noise-min-noise.store';

export function fpLoggerNoiseMinNoiseProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseMinNoiseChartService,
    FpLoggerNoiseMinNoiseExportService,
    FpLoggerNoiseMinNoiseStore,
    FpLoggerNoiseMinNoiseConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseMinNoiseConnectService,
      multi: true,
    },
  ];
}
